import { HookResult, RejectType, Transition, UIRouter } from "@uirouter/angular";
import { ISidebarOptions } from "app/types/menu";

export function transitionErrorConfigFn(router: UIRouter) {
  router.transitionService.onError(
    {
      to: (state) => state.includes.ng2Root
    },
    _onError
  )
}

function _onError(transition: Transition): HookResult {
  const error = transition.error();
  if(error.type == RejectType.ERROR) {
    const menuOptions: ISidebarOptions = transition.params().menuOptions;
    const params = {
      menuOptions: menuOptions?.sections?.length > 0 ? menuOptions : <ISidebarOptions>{
        languageToggle: false,
        sections: []
      },
      error: error
    }
    transition.abort();
    transition.router.stateService.go('error.oops', params);
  }
}
